<script setup>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import moment from "moment";
import DateRangePicker from "daterangepicker";
import { ref, onMounted } from "vue";

import { useBudgetStore } from "@/stores/budgetStore";
import BudgetsModal from "@/components/modal/budgets-modal.vue";

const title = ref("Budgets");
const text = ref("HR");
const text1 = ref("Budgets");

const budgetStore = useBudgetStore();
const budgetsModalRef = ref(null);
const dateRangeInput = ref(null);

const columns = [
  { sorter: false },
  {
    title: "Budget Title",
    dataIndex: "title",
    key: "title",
    sorter: {
      compare: (a, b) => {
        const an = (a.title || "").toLowerCase();
        const bn = (b.title || "").toLowerCase();
        return an > bn ? -1 : bn > an ? 1 : 0;
      },
    },
  },
  {
    title: "Budget Type",
    dataIndex: "budget_type",
    key: "budget_type",
    sorter: {
      compare: (a, b) => {
        const an = (a.budget_type || "").toLowerCase();
        const bn = (b.budget_type || "").toLowerCase();
        return an > bn ? -1 : bn > an ? 1 : 0;
      },
    },
  },
  {
    title: "Start Date",
    dataIndex: "start_date",
    key: "start_date",
    sorter: true,
  },
  {
    title: "End Date",
    dataIndex: "end_date",
    key: "end_date",
    sorter: true,
  },
  {
    title: "Total Revenue",
    dataIndex: "total_revenue",
    key: "total_revenue",
    sorter: true,
  },
  {
    title: "Total Expense",
    dataIndex: "total_expense",
    key: "total_expense",
    sorter: true,
  },
  {
    title: "Tax Amount",
    dataIndex: "tax_amount",
    key: "tax_amount",
    sorter: true,
  },
  {
    title: "Budget Amount",
    dataIndex: "budget_amount",
    key: "budget_amount",
    sorter: true,
  },
  {
    title: "",
    key: "action",
    sorter: false,
  },
];

const rowSelection = {
  onChange: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
};

function formatMoney(val) {
  const num = Number(val || 0);
  return num.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function openCreate() {
  budgetsModalRef.value?.openCreate();
}
function handleEdit(row) {
  budgetsModalRef.value?.openEdit(row);
}
function handleDelete(row) {
  budgetsModalRef.value?.openDelete(row);
}

/* Date range filter similar to estimates */
function booking_range(start, end) {
  const from = start.format("YYYY-MM-DD");
  const to = end.format("YYYY-MM-DD");

  budgetStore.filters.from_date = from;
  budgetStore.filters.to_date = to;

  budgetStore.fetch({ page: 1 });

  return start.format("M/D/YYYY") + " - " + end.format("M/D/YYYY");
}

onMounted(() => {
  budgetStore.fetch({ page: 1 });

  if (dateRangeInput.value) {
    const start = moment().subtract(6, "days");
    const end = moment();

    new DateRangePicker(
      dateRangeInput.value,
      {
        startDate: start,
        endDate: end,
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [
            moment().subtract(1, "days"),
            moment().subtract(1, "days"),
          ],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        },
      },
      booking_range
    );

    booking_range(start, end);
  }
});
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <div class="mb-2">
            <a
              href="javascript:void(0);"
              class="btn btn-primary d-flex align-items-center"
              @click.prevent="openCreate"
              v-can="'Budget.Create'"
            >
              <i class="ti ti-circle-plus me-2"></i>Add Budget
            </a>
          </div>
          <div class="ms-2 head-icons">
            <a
              href="javascript:void(0);"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- Budgets list -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Budget List</h5>
          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
          >
            <div class="dropdown me-2">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Sort By : Last 7 Days
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">
                    Recently Added
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">
                    Ascending
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">
                    Desending
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">
                    Last Month
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1">
                    Last 7 Days
                  </a>
                </li>
              </ul>
            </div>

            <!-- Date range input (optional visible control) -->
            <div class="mb-2">
              <input
                ref="dateRangeInput"
                type="text"
                class="form-control"
                style="max-width: 220px"
                placeholder="Filter by date range"
              />
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <a-table
              class="table datatable thead-light"
              :columns="columns"
              :data-source="budgetStore.items"
              :row-selection="rowSelection"
              :loading="budgetStore.loading"
              row-key="id"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'title'">
                  <h6 class="fw-medium">
                    <a href="javascript:void(0);">{{ record.title }}</a>
                  </h6>
                </template>

                <template v-else-if="column.key === 'budget_type'">
                  <span class="badge bg-soft-primary text-capitalize">
                    {{ record.budget_type }}
                  </span>
                </template>

                <template v-else-if="column.key === 'total_revenue'">
                  {{ formatMoney(record.total_revenue) }}
                </template>

                <template v-else-if="column.key === 'total_expense'">
                  {{ formatMoney(record.total_expense) }}
                </template>

                <template v-else-if="column.key === 'tax_amount'">
                  {{ formatMoney(record.tax_amount) }}
                </template>

                <template v-else-if="column.key === 'budget_amount'">
                  {{ formatMoney(record.budget_amount) }}
                </template>

                <template v-else-if="column.key === 'action'">
                  <div class="action-icon d-inline-flex">
                    <a
                      href="javascript:void(0);"
                      class="me-2"
                      @click.prevent="handleEdit(record)"
                      v-can="'Budget.Edit'"
                    >
                      <i class="ti ti-edit"></i>
                    </a>
                    <a
                      href="javascript:void(0);"
                      @click.prevent="handleDelete(record)"
                      v-can="'Budget.Delete'"
                    >
                      <i class="ti ti-trash"></i>
                    </a>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /Budgets list -->
    </div>
    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <budgets-modal ref="budgetsModalRef" />
</template>


